import React from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';

import { OnlyContinueButton } from 'components/base/BottomStepComponent';
import 'components/campaign/campaignCreation/CreateCampaignStepOne.scss';

import { validate } from './CreateEarningRuleValidate';

import './CreateEarningRuleStepOne.scss';
import { CREATION_STEP_ONE_CONFIG } from './EarningRuleCreationConfig';
import { createAction } from 'utils';
import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';

const mapPropsToState = (state) => ({
  status: state.createEarningRules.createStatus,
  languages: state.language.allList,
  skusHaveLoaded: state.createEarningRules.skusHaveLoaded,
});
const CreateEarningRuleStepOneV2 = () => {
  const dispatch = useDispatch();
  const {
    getValues,
    watch,
    clearErrors,
    setError,
  } = useFormContext();
  const {
    extraValidate,
  } = CREATION_STEP_ONE_CONFIG
  const earningRuleType = watch('type');

  const goToNextStep = () => {
    let isValid = validate({
      getValues,
      setError,
      clearErrors,
      step: 0,
      isBack: false,
    })
    if (extraValidate) {
      isValid = extraValidate({
        getValues,
        setError,
        clearErrors
      }) && isValid
    }
    dispatch(createAction("createEarningRules/stepChange")({
      step: 0,
      isValid,
    }))
  };

  return (
    <>
      <BaseCreationStepContentByConfig
        configuration = {CREATION_STEP_ONE_CONFIG}
        hidePreview={true}
      />
      <OnlyContinueButton
        continueAction={async () => {
          goToNextStep();
        }}
        disabledContinue={!earningRuleType}
      />
    </>
  );
}
export default connect(mapPropsToState)(CreateEarningRuleStepOneV2);
